<template>
    <div>
        <Loader :loader="isLoading" />
        <b-modal
            @shown="addScrollEvent"
            id="terms-of-use-modal"
            size="lg"
            scrollable
            no-close-on-backdrop
            no-close-on-esc
        >
            <template #modal-header>
                <div class="d-flex justify-content-between alig-items-center w-100">
                    <div class="modal-terms-of-use-title">Termos de Uso</div>
                    <div>V{{ termsOfUseVersion }}</div>
                </div>
            </template>
            <template #default>
                <div v-html="termsOfUseText"></div>
            </template>
            <template #modal-footer>
                <div class="d-flex justify-content-between align-items-flex-end flex-wrap w-100">
                    <b-checkbox
                        id="checkbox-terms-of-use-accept"
                        v-model="acceptedTermsOfUse"
                        @change="onAcceptTerms"
                        :class="[showAcceptCheckBox ? 'visible' : 'invisible', 'd-flex align-items-center mb-2']"
                    >
                        <strong> Declaro que li e concordo com os Termos de Uso </strong>
                    </b-checkbox>
                    <div class="btn-accept-wrapper pt-2">
                        <b-button
                            id="btn-terms-of-use-save"
                            variant="primary"
                            :disabled="!acceptedTermsOfUse"
                            @click="acceptTermsOfUse"
                        >
                            <b-spinner small v-if="isSubmitting"></b-spinner>
                            <span v-else>Aceitar</span>
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import api from '@/services/api'
import Loader from '@/views/components/loader'

export default {
    name: 'TermsOfUse',
    components: {
        Loader,
    },
    data() {
        return {
            acceptedTermsOfUse: false,
            termsOfUse: null,
            isLoading: false,
            isSubmitting: false,
            showAcceptCheckBox: false,
        }
    },
    created() {
        this.getTermsOfUse()
    },
    mounted() {
        window.addEventListener('load', () => {
            this.addScrollEvent()
        })
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)
        window.removeEventListener('load', this.addScrollEvent)
    },
    methods: {
        getTermsOfUse() {
            this.isLoading = true
            api.get('/terms-of-use')
                .then((response) => {
                    this.termsOfUse = response.data.data
                    this.isLoading = false
                })
                .catch((error) => {
                    console.error(error)
                })
                .finally(() => {
                    this.$bvModal.show('terms-of-use-modal')
                })
        },
        acceptTermsOfUse() {
            this.isSubmitting = true
            api.post('/terms-of-use/accept', {
                checked: this.acceptedTermsOfUse,
            })
                .then(() => {
                    this.isSubmitting = false
                    this.$bvModal.hide('terms-of-use-modal')
                    this.$router.push({ name: 'Home' })
                })
                .catch((error) => {
                    console.error(error)
                })
        },
        onAcceptTerms() {
            this.acceptedTermsOfUse = true
        },
        addScrollEvent() {
            const modalBody = document.getElementsByClassName('modal-body')
            if (modalBody.length > 0) {
                modalBody[0].addEventListener('scroll', () => {
                    this.onScroll(modalBody[0])
                })
            }
        },
        onScroll(scrollingElement) {
            const { scrollTop, scrollHeight, offsetHeight } = scrollingElement
            const zoomModifier = 1
            const bottomOfDiv = scrollHeight - zoomModifier
            if (offsetHeight + scrollTop >= bottomOfDiv) {
                this.showAcceptCheckBox = true
            }
        },
    },
    computed: {
        termsOfUseText() {
            return this.termsOfUse ? this.termsOfUse.term : null
        },
        termsOfUseVersion() {
            return this.termsOfUse ? this.termsOfUse.version : null
        },
    },
}
</script>

<style lang="scss">
#terms-of-use-modal {
    .modal-terms-of-use-title {
        font-size: 1.2em;
        font-weight: 500;
        text-align: left;
    }
    article.terms-of-use {
        font-size: 12px;
        line-height: 150%;
        text-align: justify;
    }
    article.terms-of-use h2,
    article.terms-of-use h3,
    article.terms-of-use h4 {
        font-size: inherit;
        line-height: inherit;
        text-align: inherit;
        font-family: inherit;
    }
    .title {
        font-size: 14px;
        text-align: center;
    }
    .sla-table {
        border-collapse: collapse;
        width: 100%;

        td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
        }
    }

    @media only screen and (max-width: 767px) {
        .btn-accept-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding-top: 10px;
        }
        #btn-terms-of-use-save {
            width: 40%;
            margin: 0 auto;
        }
    }
}
</style>
